export default __webpack_public_path__ + "static/media/logo-md.de9f3546.svg";